import React, { useEffect, useState, memo } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  // Start at 14 minutes 55 seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 55);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-red text-white py-3 px-4 shadow-lg" data-id="element-111">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center text-center gap-2" data-id="element-112">
        <p className="font-oswald font-semibold text-sm sm:text-base tracking-wider" data-id="element-113">
          INSTANT ACCESS: Download the Digital Commemorative Edition + 3
          Exclusive Bonuses. Limited-time launch offer.
        </p>
        <div className="flex items-center gap-1.5 font-oswald font-bold text-lg bg-black/20 px-3 py-1 rounded" data-id="element-114">
          <Clock className="w-4 h-4" data-id="element-115" />
          <span data-id="element-116">Offer ends in: [{formattedTime}]</span>
        </div>
      </div>
    </div>;
}